import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		// /?safe&mock-data&utm_source=FB&country=US&area=main&exp=web_sunday_offer_landing~1
		main: {
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_sunday_offer_landing'),
			},
		},
		// /tai-chi-walking?safe&mock-data&utm_source=FB&country=US&area=main-tai-chi-walking&exp=web_sunday_offer_landing~1
		'main-tai-chi-walking': {
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_sunday_offer_landing'),
			},
		},
		// /chair-tai-chi-pr?safe&mock-data&utm_source=FB&country=US&area=main-chair-tai-chi-pr&exp=web_sunday_offer_landing~1
		'main-chair-tai-chi-pr': {
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_sunday_offer_landing'),
			},
		},
		// /chair-tai-chi-m?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_sunday_offer_landing~1
		'activity-male-chair-tai-chi': {
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_sunday_offer_landing'),
			},
		},
		// /walking-f-al?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking-al&exp=web_sunday_offer_landing~1
		'activity-female-walking-al': {
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_sunday_offer_landing'),
			},
		},
		// /water-fasting?safe&mock-data&utm_source=FB&country=US&area=main-water-fasting&exp=web_sunday_offer_landing~1
		'main-water-fasting': {
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_sunday_offer_landing'),
			},
		},
	},
]

export default config
